
import React from "react";
import makeZapierRequest from "../../zapier/zapier";
import * as s from "./Subscribe.module.css";
import ThankYou from './ThankYou/ThankYou';
const Subscribe = ({ pageTitle }) => {
  const [email, setEmail] = React.useState("");
  const [errors, setErrors] = React.useState({
    email: false,
  });
  const [messageSent, setMessageSent] = React.useState(false);

  const submitForm = () => {
    if (isValidForm()) {
      setMessageSent(true);
      let payload = {
        event: 'formSubmit',
        type: 'subscribe',
        email: email,
        page: pageTitle,
      };
      makeZapierRequest(payload);
    }
  }

  const isValidForm = () => {
    let isValid = true;
    let newErrors = {
      email: false,
    };

    if (!isEmailValid(email)) {
      isValid = false;
      newErrors.email = 'Please enter a valid Email';
    }
    setErrors(newErrors);
    // isValid = false;
    return isValid;
  }

  const isEmailValid = (email) => {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  }

  return (
    <>
      <div className={`${s.subscribeBlock} position-relative`} id="form">
        {true === messageSent
          ? <ThankYou />
          : <div className={`${s.contactForm}`}>
            <input
              type="email"
              name="email"
              placeholder={'email:'}
              className={`form-control ${s.subscribeEmail} ${false !== errors?.email ? 'is-invalid' : ''} ${true === messageSent ? '' : ''}`}
              value={email}
              onChange={e => {
                setEmail(e.target.value);
                setMessageSent(false);
              }}
            />
            <button className={`${s.contactFormSubmitButton}`} type="button" onClick={submitForm} >SUBSCRIBE</button>
          </div>
        }
      </div>
    </>
  );
};

export default Subscribe;
